/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Matrix_DescriptionInputs */



/**
* | output |
* | --- |
* | "The organization default plus every team and user with an explicit override. Inherited cells show the organization default only — team grants or floors a use..." |
*
* @param {Rights_Matrix_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_matrix_description = /** @type {((inputs?: Rights_Matrix_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Matrix_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Organisationsstandard sowie alle Teams und Nutzer mit einer expliziten Ausnahme. Geerbte Zellen zeigen nur den Organisationsstandard – Team-Gewährungen oder -Sperren, die ein Nutzer erbt, sind nicht berücksichtigt; der effektive Zugriff kann abweichen.")
	return /** @type {LocalizedString} */ ("The organization default plus every team and user with an explicit override. Inherited cells show the organization default only — team grants or floors a user inherits are not reflected, so effective access can differ.")
});